import axios from "axios";
import getConfig from "next/config";

const { publicRuntimeConfig: { TRISBEE_API_HOST }} = getConfig();

const trisbeeAxios = axios.create({
    baseURL: TRISBEE_API_HOST,
})

trisbeeAxios.interceptors.request.use(async (config) => {
    config.headers['Content-Type'] = 'application/json';
    if (!config.data) {
        config.data = {};
    }
    return config;
})

export {trisbeeAxios}
